export default __webpack_public_path__ + "static/media/NEAR.eb50acb6.png";